import { SendOutlined, UserAddOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Form,
  Modal as AntModal,
  DatePicker,
  Select,
} from "antd";
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import useToken from "../Authentication/useToken";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Constants from "../Utils/Constants";

function CreatePatient({
  refetchPatients,
  onClose,
  initialValues,
  onPatientCreated,
  eligibilityAssignmentId,
  eligibilityRequestId,
  eligibilityRequestDisplayId,
}) {
  const { t } = useTranslation("Patients");
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: initialValues || {},
  });
  const { token } = useToken();
  const [caregivers, setCaregivers] = useState([{ id: 1 }]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isErrorMessage, setIsErrorMessage] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    reset(initialValues || {});
  }, [initialValues, reset]);


  const [showCaregiverForm, setShowCaregiverForm] = useState(false); // ?tat pour gérer la visibilité du formulaire
  const [hasCaregiver, setHasCaregiver] = useState(false);
  const [maxCaregiver, setmaxCaregiver] = useState(false);

  // Fonction pour basculer l'affichage du formulaire
  const toggleCaregiverForm = () => {
    setShowCaregiverForm(!showCaregiverForm);
    setHasCaregiver(!hasCaregiver);
  };

  const addCaregiver = () => {
    if (caregivers.length === 1) {
      // Ajouter un soignant
      setCaregivers([...caregivers, { id: caregivers.length + 1 }]);
      setmaxCaregiver(!maxCaregiver);
    } else {
      // Retirer le dernier soignant
      setCaregivers(caregivers.slice(0, -1));
      setmaxCaregiver(!maxCaregiver);
    }
  };
  /*
  const onSubmit = (data) => {
    const caregiversData = caregivers
      .map((_cg, index) => ({
        firstname: data[`caregiverFirstName${index + 1}`],
        lastname: data[`caregiverLastName${index + 1}`],
        email: data[`caregiverEmail${index + 1}`],
        phoneNumber: data[`caregiverPhone${index + 1}`],
        relationship: data[`relationship${index + 1}`],
        program: data[`program${index + 1}`],
        programStart: data[`programStart${index + 1}`]?.format("YYYY-MM-DD"),
        programEnd: data[`programEnd${index + 1}`]?.format("YYYY-MM-DD"),
        active: true,
      }))
      .filter((cg) => cg.firstname && cg.lastname);
    const patientData = {
      firstname: data.patientFirstName,
      lastname: data.patientLastName,
      email: data.patientEmail,
      phoneNumber: data.patientPhone,
      birthday: data.birthday?.format("YYYY-MM-DD"),
      otherinfo: data.otherinfo,
      numberOfCaregivers: caregiversData.length,
      weight: data.weight ? parseFloat(data.weight) : null,
      weightUnit: data.weightUnit,
      // status: 'active'
    };

    const endpoint =
      caregiversData.length > 0
        ? "/create-patient-caregiver"
        : "/create-patient";
    const payload =
      caregiversData.length > 0
        ? { patientData, caregivers: caregiversData }
        : patientData;

    axios
      .post(`${Constants.SERVER_URL}${endpoint}`, payload, {
        headers: { Authorization: "Bearer " + token },
      })
      .then((res) => {
        refetchPatients();
        openModal(t("success_create_patient"), false);
      })
      .catch((err) =>
        openModal(
          t(`Backend:${err.response.data.message}`) ||
            t("error_create_patient"),
          true
        )
      );
  };
  */
  const onSubmit = async (data) => {
    // 1) Soignants saisis dans le formulaire (SANS infos programme ici)
    const caregiversData = caregivers
      .map((_cg, index) => ({
        firstname: data[`caregiverFirstName${index + 1}`],
        lastname: data[`caregiverLastName${index + 1}`],
        email: data[`caregiverEmail${index + 1}`],
        phoneNumber: data[`caregiverPhone${index + 1}`],
        relationship: data[`relationship${index + 1}`],
      }))
      .filter((cg) => cg.firstname && cg.lastname);

    // 2) Données patient
    const patientData = {
      firstname: data.patientFirstName,
      lastname: data.patientLastName,
      email: data.patientEmail,
      phoneNumber: data.patientPhone,
      birthday: data.birthday?.format("YYYY-MM-DD"),
      otherinfo: data.otherinfo,
      numberOfCaregivers: caregiversData.length,
      weight: data.weight ? parseFloat(data.weight) : null,
      weightUnit: data.weightUnit,
      height: data.height ? Number(data.height) : null,
      gender: data.gender || null,
      ...(caregiversData.length > 0 ? { caregivers: caregiversData } : {}),
      ...(eligibilityAssignmentId ? { eligibilityAssignmentId } : {}),
      ...(eligibilityRequestId ? { eligibilityRequestId } : {}),
    };

    try {
      const response = await axios.post(
        `${Constants.SERVER_URL}/create-patient`,
        patientData,
        { headers: { Authorization: "Bearer " + token } }
      );

      if (typeof onPatientCreated === "function") {
        const createdPatient = response?.data?.patient || response?.data || null;
        if (createdPatient) {
          await onPatientCreated({
            ...createdPatient,
            linkedEligibilityRequestId: response?.data?.linkedEligibilityRequestId || null,
          });
        }
      }

      refetchPatients();
      openModal(t("success_create_patient"), false);
    } catch (err) {
      const backendMsg = err?.response?.data?.message;
      openModal(t(`Backend:${backendMsg}`) || t("error_create_patient"), true);
    }
  };

  const openModal = (message, isError) => {
    setMessage(message);
    setIsErrorMessage(isError);
    AntModal[isError ? "error" : "success"]({
      content: message,
      okText: "button_close",
      centered: true,
      onOk: () => {
        if (!isError) {
          refetchPatients();
          onClose();
        }
        closeModal();
      },
    });
  };

  const closeModal = () => {
    setIsOpenModal(false);
    setMessage("");
    setIsErrorMessage(false);
  };

 return (
  <Row justify="center">
    <Col span={16}>
      <Form layout="vertical" onFinish={handleSubmit(onSubmit)}>
        {eligibilityRequestDisplayId ? (
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="ID de la requête">
                <Input
                  value={eligibilityRequestDisplayId}
                  readOnly
                  style={{ backgroundColor: "#f5f5f5", color: "#595959" }}
                />
              </Form.Item>
            </Col>
          </Row>
        ) : null}

        <h2>{t("patient_informations")}</h2>

        {/* Nom & Prénom */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label={t("label_first_name")}
              required
              validateStatus={errors.patientFirstName ? "error" : ""}
              help={errors.patientFirstName?.message}
            >
              <Controller
                name="patientFirstName"
                control={control}
                rules={{
                  required: t("error_first_name_required"),
                  minLength: { value: 2, message: t("error_last_name_min_length") },
                }}
                render={({ field }) => (
                  <Input {...field} placeholder={t("placeholder_first_name")} />
                )}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={t("label_last_name")}
              required
              validateStatus={errors.patientLastName ? "error" : ""}
              help={errors.patientLastName?.message}
            >
              <Controller
                name="patientLastName"
                control={control}
                rules={{
                  required: t("error_last_name_required"),
                  minLength: { value: 2, message: t("error_last_name_min_length") },
                }}
                render={({ field }) => (
                  <Input {...field} placeholder={t("placeholder_last_name")} />
                )}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Date de naissance & Téléphone */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label={t("label_birthday")}>
              <Controller
                name="birthday"
                control={control}
                render={({ field }) => (
                  <DatePicker
                    {...field}
                    placeholder={t("placeholder_birthday")}
                    style={{ width: "100%" }}
                  />
                )}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={t("label_phone_number")}
              required
              validateStatus={errors.patientPhone ? "error" : ""}
              help={errors.patientPhone?.message}
            >
              <Controller
                name="patientPhone"
                control={control}
                rules={{
                  required: t("error_phone_number_required"),
                  pattern: {
                    value: /^[0-9+\s-]{8,}$/,
                    message: t("error_phone_number_invalid"),
                  },
                }}
                render={({ field }) => (
                  <Input {...field} placeholder={t("placeholder_phone_number")} />
                )}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Email & Confirmation */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label={t("label_email")}
              required
              validateStatus={errors.patientEmail ? "error" : ""}
              help={errors.patientEmail?.message}
            >
              <Controller
                name="patientEmail"
                control={control}
                rules={{
                  required: t("error_email_required"),
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: t("error_email_invalid"),
                  },
                }}
                render={({ field }) => (
                  <Input type="email" {...field} placeholder={t("placeholder_email")} />
                )}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={t("label_confirm_email")}
              required
              validateStatus={errors.confirmPatientEmail ? "error" : ""}
              help={errors.confirmPatientEmail?.message}
            >
              <Controller
                name="confirmPatientEmail"
                control={control}
                rules={{
                  required: t("error_confirm_email_required"),
                  validate: (value) =>
                    value === control._formValues.patientEmail ||
                    t("error_confirm_email_invalid"),
                }}
                render={({ field }) => (
                  <Input
                    type="email"
                    {...field}
                    placeholder={t("placeholder_confirm_email")}
                  />
                )}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Infos additionnelles */}
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label={t("label_additionnal_information")}>
              <Controller
                name="otherinfo"
                control={control}
                render={({ field }) => (
                  <Input.TextArea
                    {...field}
                    placeholder={t("placeholder_additionnal_information")}
                    rows={4}
                  />
                )}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Poids : unité AVANT la valeur */}
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label={t("label_weight")}>
              <Input.Group compact>
                <Controller
                  name="weightUnit"
                  control={control}
                  defaultValue="kg"
                  render={({ field }) => (
                    <Select {...field} style={{ width: "25%" }}>
                      <Select.Option value="kg">{t("option_kg")}</Select.Option>
                      <Select.Option value="lbs">{t("option_lbs")}</Select.Option>
                    </Select>
                  )}
                />
                <Controller
                  name="weight"
                  control={control}
                  rules={{
                    pattern: {
                      value: /^\d{1,3}(\.\d{1})?$/, // 0?999.9
                      message: t("error_weight_invalid"),
                    },
                  }}
                  render={({ field }) => (
                    <Input
                      {...field}
                      style={{ width: "75%" }}
                      placeholder={t("placeholder_weight")}
                    />
                  )}
                />
              </Input.Group>
            </Form.Item>
          </Col>
        </Row>

        {/* Taille et sexe */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label={t("label_height")}>
              <Controller
                name="height"
                control={control}
                rules={{
                  pattern: {
                    value: /^\d{1,3}(\.\d{1,2})?$/, // ex: 175 ou 175.5
                    message: t("error_height_invalid"),
                  },
                }}
                render={({ field }) => (
                  <Input {...field} placeholder={t("placeholder_height_cm")} />
                )}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label={t("label_gender")}>
              <Controller
                name="gender"
                control={control}
                render={({ field }) => (
                  <Select {...field} allowClear placeholder={t("placeholder_gender")}>
                    <Select.Option value="male">{t("option_male")}</Select.Option>
                    <Select.Option value="female">{t("option_female")}</Select.Option>
                    <Select.Option value="other">{t("option_other")}</Select.Option>
                  </Select>
                )}
              />
            </Form.Item>
          </Col>
        </Row>

        {/* Toggle caregiver */}
        <Button
          type="dashed"
          onClick={toggleCaregiverForm}
          icon={<UserAddOutlined />}
          style={{ marginBottom: 24 }}
        >
          {hasCaregiver ? t("button_without_caregiver") : t("button_with_caregiver")}
        </Button>

        {showCaregiverForm && (
          <div>
            <h2>{t("title_caregiver_information")}</h2>
            {caregivers.map((caregiver, index) => (
              <div key={caregiver.id}>
                <h3>
                  {t("label_caregiver")} {index + 1}
                </h3>

                <Row gutter={16}>
                  <Col span={8}>
                    <Form.Item
                      label={t("label_first_name")}
                      validateStatus={errors[`caregiverFirstName${index + 1}`] ? "error" : ""}
                      help={errors[`caregiverFirstName${index + 1}`]?.message}
                    >
                      <Controller
                        name={`caregiverFirstName${index + 1}`}
                        control={control}
                        rules={{
                          required: t("error_first_name_required"),
                          minLength: { value: 2, message: t("error_last_name_min_length") },
                        }}
                        render={({ field }) => (
                          <Input
                            {...field}
                            placeholder={t("placeholder_caregiver_first_name")}
                          />
                        )}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      label={t("label_last_name")}
                      validateStatus={errors[`caregiverLastName${index + 1}`] ? "error" : ""}
                      help={errors[`caregiverLastName${index + 1}`]?.message}
                    >
                      <Controller
                        name={`caregiverLastName${index + 1}`}
                        control={control}
                        rules={{
                          required: t("error_last_name_required"),
                          minLength: { value: 2, message: t("error_last_name_min_length") },
                        }}
                        render={({ field }) => (
                          <Input
                            {...field}
                            placeholder={t("placeholder_caregiver_last_name")}
                          />
                        )}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      label={t("label_relationship")}
                      validateStatus={errors[`relationship${index + 1}`] ? "error" : ""}
                      help={errors[`relationship${index + 1}`]?.message}
                    >
                      <Controller
                        name={`relationship${index + 1}`}
                        control={control}
                        rules={{ required: t("error_relashionship_required") }}
                        render={({ field }) => (
                          <Select {...field} placeholder={t("placeholder_relationship")}>
                            <Select.Option value="parent">{t("option_parent")}</Select.Option>
                            <Select.Option value="sibling">{t("option_sibling")}</Select.Option>
                            <Select.Option value="friend">{t("option_friend")}</Select.Option>
                            <Select.Option value="volunteer_companion">
                              {t("option_volunteer_companion")}
                            </Select.Option>
                            <Select.Option value="professional_caregiver">
                              {t("option_professional_caregiver")}
                            </Select.Option>
                            <Select.Option value="colleague">{t("option_colleague")}</Select.Option>
                            <Select.Option value="spouse">{t("option_spouse")}</Select.Option>
                            <Select.Option value="child">{t("option_child")}</Select.Option>
                            <Select.Option value="community_member">
                              {t("option_community_member")}
                            </Select.Option>
                            <Select.Option value="nephew_niece">
                              {t("option_nephew_niece")}
                            </Select.Option>
                            <Select.Option value="grandchild">{t("option_grandchild")}</Select.Option>
                            <Select.Option value="neighbor">{t("option_neighbor")}</Select.Option>
                            <Select.Option value="other">{t("option_other")}</Select.Option>
                          </Select>
                        )}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      label={t("label_email")}
                      validateStatus={errors[`caregiverEmail${index + 1}`] ? "error" : ""}
                      help={errors[`caregiverEmail${index + 1}`]?.message}
                    >
                      <Controller
                        name={`caregiverEmail${index + 1}`}
                        control={control}
                        rules={{
                          required: t("error_email_required"),
                          pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: t("error_email_invalid"),
                          },
                        }}
                        render={({ field }) => (
                          <Input
                            type="email"
                            {...field}
                            placeholder={t("placeholder_caregiver_email")}
                          />
                        )}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      label={t("label_phone_number")}
                      validateStatus={errors[`caregiverPhone${index + 1}`] ? "error" : ""}
                      help={errors[`caregiverPhone${index + 1}`]?.message}
                    >
                      <Controller
                        name={`caregiverPhone${index + 1}`}
                        control={control}
                        rules={{
                          required: t("error_phone_number_required"),
                          pattern: { value: /^[0-9+\s-]{8,}$/, message: t("error_phone_number_invalid") },
                        }}
                        render={({ field }) => (
                          <Input {...field} placeholder={t("placeholder_caregiver_phone")} />
                        )}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
            ))}
            <Button
              type="dashed"
              onClick={addCaregiver}
              icon={<UserAddOutlined />}
              style={{ marginBottom: 24 }}
            >
              {maxCaregiver ? t("button_caregiver_remove") : t("button_caregiver_add")}
            </Button>
          </div>
        )}

        {/* Submit */}
        <Form.Item>
          <Button type="primary" htmlType="submit" icon={<SendOutlined />}>
            {t("button_create_patient")}
          </Button>
        </Form.Item>
      </Form>

      <AntModal
        open={isOpenModal}
        onCancel={closeModal}
        footer={[
          <Button key="close" onClick={closeModal}>
            {t("button_close")}
          </Button>,
        ]}
      >
        <p style={{ color: isErrorMessage ? "#ff4d4f" : "#52c41a" }}>{message}</p>
      </AntModal>
    </Col>
  </Row>
);
}

CreatePatient.propTypes = {
  refetchPatients: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
  onPatientCreated: PropTypes.func,
  eligibilityAssignmentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  eligibilityRequestId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  eligibilityRequestDisplayId: PropTypes.string,
};

export default CreatePatient;

